var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.262,
    height: 66.262,
    viewBox: "0 0 66.262 66.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#c0321f;}.a{stroke:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4919.494 20551.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36.006,7.768A28.244,28.244,0,0,1,55.977,55.977,28.244,28.244,0,0,1,16.035,16.035,28.046,28.046,0,0,1,36.006,7.768m0-4.393A32.631,32.631,0,1,0,68.637,36.006,32.626,32.626,0,0,0,36.006,3.375Z",
    transform: "translate(4916.619 -20554.375)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4938.803 -20535.371)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M72.986,4.253H67.139V3.19A3.19,3.19,0,0,0,63.949,0H59.7a3.19,3.19,0,0,0-3.19,3.19V4.253H50.658A2.658,2.658,0,0,0,48,6.911V9.038A1.063,1.063,0,0,0,49.063,10.1H74.581a1.063,1.063,0,0,0,1.063-1.063V6.911A2.658,2.658,0,0,0,72.986,4.253ZM58.633,3.19A1.065,1.065,0,0,1,59.7,2.127h4.253A1.065,1.065,0,0,1,65.012,3.19V4.253h-6.38Z",
    transform: "translate(-48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M73.7,184a.332.332,0,0,0-.332.348l.877,18.41a3.186,3.186,0,0,0,3.186,3.038H93.574a3.186,3.186,0,0,0,3.186-3.038l.877-18.41a.332.332,0,0,0-.332-.348Zm16.057,2.658a1.063,1.063,0,0,1,2.127,0V200.48a1.063,1.063,0,1,1-2.127,0Zm-5.316,0a1.063,1.063,0,0,1,2.126,0V200.48a1.063,1.063,0,1,1-2.126,0Zm-5.316,0a1.063,1.063,0,0,1,2.126,0V200.48a1.063,1.063,0,1,1-2.126,0Z",
    transform: "translate(-71.679 -171.773)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCircleIcon);
export default __webpack_public_path__ + "static/media/trash-circle-icon.62685772c91e749122c9456951f49371.svg";
export { ForwardRef as ReactComponent };